import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Mention « Sponsorisé ».
 *
 * La mise en avant sectorielle est un espace payé par le producteur. Signaler
 * clairement une position achetée n'est pas une option de présentation : c'est
 * une obligation de loyauté envers le client, et c'est aussi ce qui préserve la
 * crédibilité du classement naturel.
 *
 * Le libellé est figé dans le composant, sans entrée configurable, pour qu'il ne
 * puisse pas être adouci en « partenaire » ou « recommandé » au fil des écrans.
 */
@Component({
  selector: 'ct-sponsored-tag',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="tag" title="Emplacement payé par le producteur">
      Sponsorisé
      <span class="ct-sr-only">— emplacement payé par le producteur</span>
    </span>
  `,
  styles: `
    .tag {
      display: inline-block;
      font-size: 0.5625rem;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.04em;
      padding: 2px 7px;
      border-radius: var(--ct-radius-pill);
      background: var(--ct-neutral);
      color: var(--ct-text-muted);
      white-space: nowrap;
    }
  `,
})
export class CtSponsoredTag {}
